import React from 'react';

import { useRouteChangeHandler } from 'shared/hooks';

import AboutUsMenu from './AboutUsMenu';

type AppHeaderItemProps = {
  title: string;
  to?: string;
  target?: string;

  subMenu?: {
    title: string;
    to: string;
    target?: string;
  }[];
};

const AppHeaderItem = ({ title, to, target, subMenu }: AppHeaderItemProps) => {
  const active = to ? window.location.pathname.startsWith(to) : false;
  const { handleRouteChange } = useRouteChangeHandler();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    window.dataLayer?.push({
      event: 'click_menu',
      menu: title,
      section: 'GNB',
    });

    if (target === '_blank') {
      window.open(to, '_blank');
      return;
    }

    if (to) {
      handleRouteChange(to);
    }
  };

  return (
    <ul>
      {subMenu ? (
        <AboutUsMenu title={title} subMenu={subMenu} />
      ) : (
        <li className={`flex cursor-pointer items-center text-b3`}>
          <a href={to} onClick={handleClick} aria-current={active ? 'page' : undefined}>
            {title}
          </a>
        </li>
      )}
    </ul>
  );
};

export default AppHeaderItem;
